export function isHeicLikeMimeType(mimeType?: string | null): boolean {
  if (!mimeType) return false;
  const normalized = mimeType.toLowerCase();
  return (
    normalized === 'image/heic' ||
    normalized === 'image/heif' ||
    normalized === 'image/heic-sequence' ||
    normalized === 'image/heif-sequence'
  );
}

export function isHeicLikePath(value?: string | null): boolean {
  if (!value) return false;
  return /\.hei(c|f)(?:$|[?#])/i.test(value);
}

export function canRenderInBrowserPreview(args: {
  mimeType?: string | null;
  urlOrName?: string | null;
}): boolean {
  if (isHeicLikeMimeType(args.mimeType)) return false;
  if (isHeicLikePath(args.urlOrName)) return false;
  return true;
}
